export default __webpack_public_path__ + "static/media/user.827f590a.jpeg";